<template>
  <div class="flex flex-col p-2">
    <div class="w-full">

      <div class="flex items-center justify-between py-3">
        <div class="grid grid-cols-4 gap-3 flex-1">
          <input type="text"
                 v-model="name"
                 placeholder="Search by Name"
                 required
                 class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                 @keyup.enter="fetch(1)"/>

          <input type="text"
                 v-model="email"
                 placeholder="Search by Email"
                 required
                 class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                 @keyup.enter="fetch(1)"/>

          <select v-model="status" @change="fetch(1)"
                  class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">--Filter by Status--</option>
            <option :value="null">All</option>
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
          </select>

          <select v-model="gender" @change="fetch(1)"
                  class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">--Filter by gender--</option>
            <option :value="null">All</option>
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>
          </select>
        </div>
        <div class="flex gap-2 ml-1">
          <button v-if="canViewMenuItem('can_edit_user_contacts')"
                  class="btn-primary" @click="openNewAccountForm">
            <i class="fa fa-plus mx-1"></i> Add Account
          </button>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <table class="min-w-full leading-normal">
            <thead>
            <tr class="border-b border-t border-gray-200">
              <th width="20%">Name</th>
              <th>Role(s)</th>
              <th>ID Number</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Date Created</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>

            <tbody>
            <template v-if="loading">
              <tr v-for="i in 6" :key="`sk-${i}`" class="animate-pulse">
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
                <td>
                  <div class="h-3 bg-gray-200 rounded w-full"></div>
                </td>
              </tr>
            </template>
            <template v-else>
            <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(account, idx) in accounts" :key="idx">
              <td class="font-bold text-uppercase">
                <span>{{ account.givenName }} {{ account.surName }}</span>
                <span class="mx-2" v-if="account.middleName !== 'null'">{{ account.middleName }}</span>
              </td>
              <td>
                              <span v-if="account.userRoles.length === 2">
                                <span v-for="(list, index) in account.userRoles" :key="index" class="text-xs">
                                  <label v-if="list.name !=='ROLE_USER'">
                                    {{ list.name.replaceAll("_", " ") }}
                                    <i class="fa fa-times-circle text-red mx-1 cursor-pointer"
                                       title="Click to remove  role from this user "
                                       @click="removeRole(list.roleId, account.id)"></i>
                                  </label>
                               </span>
                              </span>
                <span v-else @click="showUserRolesFunc(account.userRoles, account.id)"
                      class="text-xs italic text-primary cursor-pointer hover:underline">
                                {{ account.userRoles.length - 1 }} ROLES
                              </span>

              </td>
              <td>
                <span>{{ account.idNumber.split(",")[0] }}</span>
              </td>
              <td>
                              <span class="flex">
                                {{ account.email.split(",")[0] }}<i class="fa fa-check-circle text-green mx-1"
                                                                    v-if="account.emailVerified"></i>
                                <i class="fa fa-times text-orange mx-1" v-else></i>
                              </span>
              </td>
              <td>
                              <span class="flex">
                                {{ account.phoneNumber.split(",")[0] }}
                                <i class="fa fa-check-circle text-green mx-1" v-if="account.phoneVerified"></i>
                                <i class="fa fa-times text-orange mx-1" v-else></i>
                              </span>
              </td>
              <td><span>{{ formatDate(account.createdAt) }}</span></td>
              <td class="font-bold">
                <span class="text-green" v-if="account.enabled">Active</span>
                <span class="text-red" v-else>Inactive</span>
              </td>
              <td>
                <div class="flex gap-1 items-center">
                  <button class="btn-sm-primary"
                          v-if="account.enabled && canViewMenuItem('can_update_staff_signature')"
                          :title="(account.signatureUrl) ? 'Update signature' : 'Add signature'"
                          @click="openEditSignature(account)">
                    <i :class="(account.signatureUrl) ? 'fa fa-upload' : 'fa fa-upload text-red'" /> Signature
                  </button>
                  <button class="btn-sm-danger"
                          v-if="account.enabled && account.signatureUrl && canViewMenuItem('can_update_staff_signature')"
                          title="Click to remove signature"
                          @click="removeSignature(account.id)">
                    <i class="fa fa-trash" /> Remove Signature
                  </button>
                  <button class="btn-sm-danger"
                          v-if="account.enabled && canViewMenuItem('can_update_account_status')"
                          @click="changeStatus(account.id,'INACTIVE')"
                          title="Click to disable account">
                    <i class="fa fa-times" /> Disable
                  </button>
                  <button class="btn-sm-primary"
                          v-else-if="canViewMenuItem('can_update_account_status')"
                          @click="changeStatus(account.id,'ACTIVE')"
                          title="Click to activate account">
                    <i class="fa fa-check" /> Enable
                  </button>
                  <button class="btn-sm-primary"
                          v-if="!account.enabled && canViewMenuItem('can_resend_account_emails')"
                          title="Click to resend activation link"
                          @click="resendActivation(account.id)">
                    <i class="fa fa-reply" /> Resend
                  </button>
                  <button class="btn-sm-primary"
                          v-if="canViewMenuItem('can_edit_user_contacts')"
                          title="Click to edit profile"
                          @click="openEditForm(account)">
                    <i class="fa fa-pen-square" /> Edit
                  </button>
                  <button class="btn-sm-primary"
                          v-if="account.idType === 'NATIONAL_ID' && canViewMenuItem('can_revalidate_nin')"
                          :disabled="revalidatingId === account.id"
                          title="Click to revalidate NIN"
                          @click="revalidateNin(account)">
                    <i :class="revalidatingId === account.id ? 'fa fa-spinner fa-spin' : 'fa fa-sync'" /> Revalidate NIN
                  </button>
                  <button class="btn-sm-primary"
                          v-if="canViewMenuItem('can_make_account_practitioner')"
                          @click="showReceiverForm(account)">
                    <i class="fa fa-user-check" /> Make Receiver
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td v-if="accounts.length === 0" colspan="8" class="text-center py-6 text-sm text-gray-400">
                No results found
              </td>
            </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="pagination.totalPages > 1"
           class="flex items-center justify-between px-1 py-3 border-t border-gray-100 mt-2">
        <p class="text-xs text-gray-500">Page <span class="font-semibold text-gray-700">{{ currentPage }}</span> of
          <span class="font-semibold text-gray-700">{{ pagination.totalPages }}</span></p>
        <div class="flex gap-2">
          <button class="btn-sm-primary" @click="previous" :disabled="currentPage === 1">
            <i class="fa fa-chevron-left mr-1"></i> Prev
          </button>
          <button class="btn-sm-primary" @click="next" :disabled="currentPage === pagination.totalPages">
            Next <i class="fa fa-chevron-right ml-1"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <AppModal v-model="showAddAccountForm" size="lg" title="Add Account" static>
    <div class="col-span-11 mx-auto">

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <select v-model="form.idType" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option value="NATIONAL_ID">National ID</option>
          </select>
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.idNumber"
                 @keyup="validateIdTypes"
                 placeholder="National ID Number" />
          <button v-if="loaderNinProgress" class="btn-primary px-4 py-2 text-sm font-medium text-white bg-primary rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed" disabled>
                  <span class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </span>
          </button>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.surname"
                 disabled
                 placeholder="Surname" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" disabled
                 v-model="form.middleName"
                 placeholder="Middle Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.email"
                 placeholder="Email Address" />
          <label class="text-sm">Date of Birth</label>
          <input type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent mb-2" disabled
                 v-model="form.dob" />
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" disabled
                 v-model="form.givenName"
                 placeholder="Given Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="form.phoneNumber"
                 placeholder="Phone Number" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <label class="text-sm">Gender</label>
          <select v-model="form.gender" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">-- Select Gender --</option>
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>

          </select>
          <label class="text-sm">Role</label>
          <select v-model="form.roleId" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">-- Select Role --</option>
            <option v-for="(role,idx) in rolesDataList" :value="role.value" :key="idx">{{ role.text }}
            </option>

          </select>
        </div>
        <div class="col-span-12">
          <label class="text-sm">Nationality</label>
          <select v-model="form.nationality" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option v-for="option in countries" :key="option.value" :value="option.value">{{ option.text }}</option>
          </select>
          <label class="text-sm">Department</label>
          <select v-model="form.departmentId" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">-- Select Department --</option>
            <option v-for="(dept,idx) in departmentList" :value="dept.id" :key="idx">
              {{ dept.departmentName }}
            </option>

          </select>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 my-2">
        <div class="col-span-12 mx-auto w-full">
          <label class="text-sm block">Attach Signature</label>
          <input type="file" accept="image/png, image/jpeg, image/bmp" @change="onFileSelect" class="block w-full text-sm text-gray-600 file:mr-2 file:py-2 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-primary file:text-white hover:file:bg-primary-600 file:cursor-pointer border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary" />
          <div v-if="form.signature" class="mt-2 text-center w-full">
            <label class="text-xs text-gray-500 block mb-1">Cropped Signature Preview</label>
            <StaffSignature :signature-file="form.signature || ''" />
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-8"></div>
        <div class="col-span-4">
          <button :disabled="registerSpinner" class="btn-primary w-full bg-primary text-white px-4 py-2 rounded-sm flex items-center justify-center gap-1 text-sm"
                  @click="registerInternalUser">
            <i class="fa fa-save mx-1"></i> Save
            <span v-if="registerSpinner" class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
          </button>
        </div>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showEditAccountForm" size="lg" title="Edit Account">
    <div class="col-span-11 mx-auto">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <select v-model="editForm.idType" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option value="NATIONAL_ID">National ID</option>
          </select>
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.idNumber"
                 placeholder="National ID Number" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.surname"
                 placeholder="Surname" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true" v-model="editForm.middleName"
                 placeholder="Middle Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.email"
                 placeholder="Email Address" />
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true" v-model="editForm.givenName"
                 placeholder="Given Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.phoneNumber"
                 placeholder="Phone Number" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 mx-auto">
        <div class="col-span-12">
          <label class="text-sm">Gender</label>
          <select v-model="editForm.gender" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">-- Select Gender --</option>
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>

          </select>
          <label class="text-sm">Role</label>
          <select v-model="editForm.roleId" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">-- Select Role --</option>
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>

          </select>
        </div>
        <div class="col-span-12">
          <label class="text-sm">Nationality</label>
          <select v-model="editForm.nationality" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option v-for="option in countries" :key="option.value" :value="option.value">{{ option.text }}</option>
          </select>
          <label class="text-sm">Department</label>
          <select v-model="editForm.departmentId" disabled class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            <option :value="null">-- Select Department --</option>
            <option value="MALE">Male</option>
            <option value="FEMALE">Female</option>

          </select>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-10"></div>
        <div class="col-span-2">
          <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-md text-xs"
                  @click="updateUserDetails">
            <i class="fa fa-save mx-1"></i> Save changes
          </button>
        </div>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showMakeReceiverForm" size="md" title="Make Account Official Receiver">
    <div class="col-span-11 mx-auto">

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          By clicking the button below, you are making this account an official receiver
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" disabled   v-model="userName"
                 placeholder="Organisation Name" />
        </div>
      </div>

      <MakeOfficialReceiver @selected="selectIndividualAccount"/>

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-3">
          <button class="btn-primary w-full bg-red text-white px-4 py-2 rounded-md text-sm"
                  @click="showMakeReceiverForm = false">
            <i class="fa fa-times mr-1 text-xs"></i> Cancel
          </button>
        </div>

        <div class="col-span-6"></div>


        <div class="col-span-3">
          <button :disabled="loading" class="btn-primary w-full bg-green text-white px-4 py-2 rounded-md text-sm flex items-center justify-center gap-1"
                  @click="makeUserOfficialReceiver()">
            <i class="fa fa-save text-xs"></i> Accept
            <span v-if="loading" class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
          </button>
        </div>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showEditSignatureForm" size="lg" title="Edit Staff Signature" static>
    <div class="col-span-11 mx-auto">

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"  v-model="editForm.surname"
                 placeholder="Surname" />
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true" v-model="editForm.middleName"
                 placeholder="Middle Name" />
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.email"
                 readonly
                 placeholder="Email Address" />
        </div>
        <div class="col-span-12">
          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" :disabled="true"
                 v-model="editForm.givenName"
                 placeholder="Given Name"
                 readonly />

          <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2" v-model="editForm.phoneNumber"
                 readonly
                 placeholder="Phone Number" />
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <StaffSignature :user-id="editForm.userId || ''" :signature-file="editForm.signature || ''" />
        </div>
      </div>


      <div class="grid grid-cols-12 gap-4 my-2">
        <div class="col-span-12 mx-auto">
          <label class="text-sm">Attach Signature</label>
          <input type="file" accept="image/png, image/jpeg, image/bmp" @change="onFileSelect" class="block w-full text-sm text-gray-600 file:mr-2 file:py-2 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-primary file:text-white hover:file:bg-primary-600 file:cursor-pointer border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary" />
        </div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-10"></div>
        <div class="col-span-2">
          <button :disabled="updateSignatureSpinner" class="btn-primary w-full bg-primary text-white px-4 py-2 rounded-md text-sm flex items-center justify-center gap-1"
                  @click="updateStaffSignatureHandler">
            <i class="fa fa-upload text-xs"></i> Save changes
            <span v-if="updateSignatureSpinner" class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
          </button>
        </div>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showSignatureForm" size="lg" title="Staff Account Signature" static>
    <div class="bg-white rounded-lg shadow border border-gray-200 overflow-hidden mb-2">
      <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
        <h3 class="text-lg font-semibold text-gray-900">Crop staff signature</h3>
      </div>
      <div class="px-6 py-4">
        <p class="text-sm text-gray-600">
          <VueCropper v-show="selectedFile" ref="cropper" :src="selectedFile"
                      alt="Source Image"></VueCropper>
        </p>
      </div>
      <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-between">
        <button class="btn-primary px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary" @click="showSignatureForm = false">Cancel
        </button>
        <button class="btn-primary px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary" @click="saveImage(); (dialog = false) ">Crop
          signature
        </button>
      </div>
    </div>
  </AppModal>
  <AppModal v-model="showAccountRoles" title="Account Roles">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 bg-gray-10 rounded px-2 py-2">
        <p v-for="(list, index) in userRoles" :key="index" class="text-sm">
          <label v-if="list.name !=='ROLE_USER'">
            -
            {{ list.name.replaceAll("_", " ") }}
            <i class="fa fa-times-circle text-red mx-1 cursor-pointer"
               title="Click to remove  role from this user "
               @click="removeRole(list.roleId, selectedAccountId || '')"></i>
          </label>
        </p>
      </div>
    </div>
  </AppModal>
</template>

<script setup lang="ts">
import { getCurrentInstance, nextTick, onMounted, ref, watch } from "vue";
import { useAbility } from "@casl/vue";
import { useStore } from "vuex";
import { useRegisterStore } from "@/stores/register";
import { useAccountStore } from "../stores";
import { useConfirmDialog } from "@/composables";
import { useRolesStore } from "@/stores/roles";
import AppModal from "@/components/ui/AppModal.vue";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import StaffSignature from "@/domains/home/services/accounts/components/staff/StaffSignature.vue";
import MakeOfficialReceiver from "@/domains/home/services/accounts/views/MakeOfficialReceiver.vue";
import { api } from "@/app/services/api.service.ts";
import { formatDate, getReference, objectToQueryParams } from "@/commons/composables/utilities.ts";
import { useNotificationsStore } from "@/app/notify/notifications.ts";
import { UserAccount } from "@/domains/home/services/accounts/types";

interface UserRole {
    roleId: string
    name: string
}

interface Form {
    idType: string
    gender: string | null
    surname: string | null
    givenName: string | null
    middleName: string | null
    email: string | null
    phoneNumber: string | null
    roleId: string | null
    nationality: string
    idNumber: string | null
    idAttachment: File | null
    signature: string | null
    departmentId: string | null
    dob: string | null
}

interface EditForm {
    userId: string | null
    idType: string
    gender: string | null
    surname: string | null
    givenName: string | null
    middleName: string | null
    email: string | null
    phoneNumber: string | null
    roleId: string | null
    nationality: string
    idNumber: string | null
    idAttachment: string | null
    signature: string | null
    departmentId: string | null
    dob: string | null
}

interface SelectOption {
    text: string
    value: string | null
    id?: string | null
    disabled?: boolean
}

interface Country {
    value: string
    text: string
}

interface Department {
    id: string
    departmentName: string
}

interface Pagination {
    totalElements: number
    totalPages: number
}

const emit = defineEmits<{
    finished: [value: boolean]
}>()

const store = useStore()
const registerStore = useRegisterStore();
const accountStore = useAccountStore();
const rolesStore = useRolesStore();
const notify = useNotificationsStore()
const instance = getCurrentInstance()
const { showConfirm } = useConfirmDialog()

const showAddAccountForm = ref(false)
const showEditAccountForm = ref(false)
const showMakeReceiverForm = ref(false)
const showEditSignatureForm = ref(false)
const showSignatureForm = ref(false)
const showAccountRoles = ref(false)
const loading = ref(false)
const spinner = ref(false)
const currentPage = ref(1)
const limit = ref(12)
const accounts = ref<UserAccount[]>([]);
const pagination = ref<Pagination>({
    totalElements: 0,
    totalPages: 0
})
const rows = ref({
    odd: "border-t border-gray-200 hover:bg-gray-10",
    even: "border-t border-gray-200 bg-gray-10"
})
const userRoles = ref<UserRole[]>([])
const selectedAccountId = ref<string | null>(null)
const form = ref<Form>({
    idType: "NATIONAL_ID",
    gender: null,
    surname: null,
    givenName: null,
    middleName: null,
    email: null,
    phoneNumber: null,
    roleId: null,
    nationality: "UG",
    idNumber: null,
    idAttachment: null,
    signature: null,
    departmentId: null,
    dob: null
})
const editForm = ref<EditForm>({
    userId: null,
    idType: "NATIONAL_ID",
    gender: null,
    surname: null,
    givenName: null,
    middleName: null,
    email: null,
    phoneNumber: null,
    roleId: null,
    nationality: "UG",
    idNumber: null,
    idAttachment: null,
    signature: null,
    departmentId: null,
    dob: null
})
const updateSignature = ref(false)
const updateSignatureSpinner = ref(false)
const countries = ref<Country[]>([
    { value: "UG", text: "Ugandan" },
    { value: "ot", text: "Other" }
])
const status = ref<string | null>(null)
const email = ref<string | null>(null)
const name = ref<string | null>(null)
const gender = ref<string | null>(null)
const idType = ref<string | null>(null)
const nationality = ref<string | null>(null)
const mime_type = ref("")
const selectedFile = ref("")
const dialog = ref(false)
const registerSpinner = ref(false)
const signatureBlob = ref<Blob | null>(null)
const rolesDataList = ref<SelectOption[]>([])
const usersList = ref<SelectOption[]>([])
const departmentList = ref<Department[]>([])
const loaderNinProgress = ref(false)
const userName = ref<string | null>(null)
const userId = ref<string | null>(null)
const individualAccountId = ref<string | null>(null)
const cropper = ref<InstanceType<typeof VueCropper>>()

onMounted(() => {
    fetch()
    store.dispatch("fetchRoles")
    store.dispatch("fetchDepartments")
})

const saveImage = () => {
    cropper.value?.getCroppedCanvas().toBlob((blob) => {
        if (blob) {
            signatureBlob.value = blob
            const previewUrl = URL.createObjectURL(blob)
            if (showEditSignatureForm.value) {
                editForm.value.signature = previewUrl
            } else if (showAddAccountForm.value) {
                form.value.signature = previewUrl
            }
        }
    }, mime_type.value)

    showSignatureForm.value = false
}

const onFileSelect = (e: Event) => {
    showCropper()
    const target = e.target as HTMLInputElement
    const file = target.files?.[0]
    if (!file) return

    mime_type.value = file.type

    if (typeof FileReader === "function") {
        dialog.value = true
        const reader = new FileReader()
        reader.onload = (event) => {
            selectedFile.value = event.target?.result as string
            nextTick(() => {
                cropper.value?.replace(selectedFile.value)
            })
        }
        reader.readAsDataURL(file)
    } else {
        alert("Sorry, FileReader API not supported")
    }
}

const registerInternalUser = () => {
    registerSpinner.value = true

    const formData = new FormData()
    formData.set("email", form.value.email || "")
    formData.set("phoneNumber", form.value.phoneNumber || "")
    formData.set("givenName", form.value.givenName || "")
    formData.set("middleName", form.value.middleName || "")
    formData.set("surname", form.value.surname || "")
    formData.set("roleId", form.value.roleId || "")
    formData.set("nationality", form.value.nationality)
    formData.set("gender", form.value.gender || "")
    formData.set("departmentId", form.value.departmentId || "")
    formData.set("dob", form.value.dob || "")
    formData.set("idNumber", form.value.idNumber || "")
    formData.set("idType", form.value.idType)

    if (signatureBlob.value) {
        formData.set("signatureAttachment", signatureBlob.value, "file.jpeg")
    }

  registerStore.doRegisterUser(formData);
}

const updateStaffSignatureHandler = () => {
    if (!signatureBlob.value) {
        notify.warning("Please select and crop a signature first")
        return
    }
    updateSignatureSpinner.value = true
    const formData = new FormData()
    formData.set("userId", editForm.value.userId || "")
    formData.set("signature", signatureBlob.value, "file.jpeg")

  accountStore.doUpdateStaffSignature(formData);
}

const validateIdTypes = async () => {
    if (!form.value.idNumber) return

    form.value.idNumber = form.value.idNumber.toUpperCase()
    loaderNinProgress.value = false

    // Validate first two characters if they are alphabet
    if (!(/^[a-zA-Z()]+$/.test(form.value.idNumber.slice(0, 2)))) {
        notify.error("NIN starts with letters!")
        return
    }

    clearData()

    if (form.value.idNumber.length === 14) {
        loaderNinProgress.value = true
        let ninData = { nin: form.value.idNumber, reference: getReference() }
        await api().post("/integration/api/nira", ninData).then(response => {
            let data = response.data
            loaderNinProgress.value = false

            form.value.surname = data.surname
            form.value.givenName = data.givenNames
            form.value.middleName = data.middleName ? data.middleName : data.maidenNames
            form.value.gender = data.gender === "M" ? "MALE" : "FEMALE"

            let d = data.dateOfBirth
            let day = d.substring(0, 2)
            let month = d.substring(3, 5)
            let year = d.substring(6, 10)

            form.value.dob = year + "-" + month + "-" + day
        }).catch(error => {
            loaderNinProgress.value = false
            console.log(error)
            notify.error("NIN should be 14 characters!")
        })
    }
}

const clearData = () => {
    form.value.surname = ""
    form.value.givenName = ""
    form.value.middleName = ""
    form.value.gender = null
    form.value.dob = ""
}

const fetch = (startPage: number | null = null) => {
    loading.value = true
    let filters: any = { "accountType": "BACKOFFICE" }

    if (status.value) filters.accountStatus = status.value
    if (gender.value) filters.gender = gender.value
    if (idType.value) filters.idType = idType.value
    if (name.value) filters.name = name.value
    if (email.value) filters.email = email.value
    if (nationality.value) filters.nationality = nationality.value

    filters.page = startPage ? startPage : currentPage.value
    filters.perPage = limit.value

  accountStore.fetchStaffAccounts(objectToQueryParams(filters));
  loading.value = false;
}

const next = () => {
    if (currentPage.value < pagination.value.totalPages) {
        currentPage.value++
        fetch()
    }
}

const previous = () => {
    if (currentPage.value > 1) {
        currentPage.value--
        fetch()
    } else {
        notify.warning("No more data to show")
    }
}

const showUserRolesFunc = (roles: UserRole[], id: string) => {
    userRoles.value = roles
    selectedAccountId.value = id
    showAccountRoles.value = true
}

const openNewAccountForm = () => {
    signatureBlob.value = null
    form.value = {
        idType: "NATIONAL_ID",
        gender: null,
        surname: null,
        givenName: null,
        middleName: null,
        email: null,
        phoneNumber: null,
        roleId: null,
        nationality: "UG",
        idNumber: null,
        idAttachment: null,
        signature: null,
        departmentId: null,
        dob: null
    }
    showAddAccountForm.value = true
}

const openEditForm = (account: UserAccount) => {
    editForm.value = {
        userId: account.id,
        idType: "NATIONAL_ID",
        gender: account.gender,
        surname: account.surName,
        givenName: account.givenName,
        middleName: account.middleName,
        email: account.email,
        phoneNumber: account.phoneNumber,
      roleId: "",
        nationality: account.nationality,
        idNumber: account.idNumber,
      idAttachment: "",
      signature: "",
      departmentId: "",
        dob: account.dob
    }
    showEditAccountForm.value = true
}

const openEditSignature = async (account: UserAccount) => {
    signatureBlob.value = null
    editForm.value = {
        userId: account.id,
        idType: "NATIONAL_ID",
        gender: account.gender,
        surname: account.surName,
        givenName: account.givenName,
        middleName: account.middleName,
        email: account.email,
        phoneNumber: account.phoneNumber,
        roleId: null,
        nationality: account.nationality,
        idNumber: null,
        idAttachment: null,
        signature: account.signatureUrl,
        departmentId: null,
        dob: null
    }
    updateSignature.value = true
    showEditSignatureForm.value = true
    await accountStore.fetchStaffSignature({ id: account.id })
}

const closeEditForm = () => {
    showEditAccountForm.value = false
}

const closeEditSignatureForm = () => {
    signatureBlob.value = null
    showEditSignatureForm.value = false
}

const showCropper = () => {
    showSignatureForm.value = true
}

const filterUserList = (dataList: UserAccount[]) => {
    let dataObj: SelectOption[] = [{ text: "Select User", value: null, id: null }]
    for (let i = 0; i < dataList.length; i++) {
        let userData = dataList[i]
        dataObj.push({
            text: userData.surName + " " + userData.givenName,
            value: dataList[i].id
        })
    }
    return dataObj
}

const filterRolesListData = (dataList: any[]) => {
    let dataObj: SelectOption[] = [{ text: "Select Role", value: null, id: null, disabled: true }]
    for (let i = 0; i < dataList.length; i++) {
        dataObj.push({
            text: dataList[i].name,
            value: dataList[i].roleId
        })
    }
    return dataObj
}

const resendActivation = async (accountId: string) => {
    const confirmed = await showConfirm("Are you sure you want to resend the activation link?")
    if (confirmed) {
        accountStore.doResendActivationLink({ userId: accountId })
    }
}

const changeStatus = async (accountId: string, status: string) => {
    const confirmed = await showConfirm(`Are you sure you want to change this account status to ${status.toLowerCase()}?`)
    if (confirmed) {
        accountStore.changeAccountStatus({ userId: accountId, status })
    }
}

const removeRole = async (roleId: string, accountId: string) => {
    const confirmed = await showConfirm("Are you sure you want to remove this role from the user?")
    if (confirmed) {
        let payload = {
            roleIds: [roleId],
            userId: accountId
        }
        rolesStore.removeUserRole(payload)
    }
}

const removeSignature = async (userId: string) => {
    const confirmed = await showConfirm("Are you sure you want to remove this staff signature?")
    if (confirmed) {
        accountStore.doRemoveStaffSignature(userId)
    }
}

const updateUserDetails = () => {
    let data = {
        "email": editForm.value.email,
        "phone": editForm.value.phoneNumber,
        "userId": editForm.value.userId
    }

  accountStore.updateStaffContacts(data);
}

const { can } = useAbility();
const canViewMenuItem = (permission: string) => can(permission, "general") === true;

const revalidatingId = ref<string | null>(null)

const revalidateNin = async (account: UserAccount) => {
    const nin = account.idNumber?.split(",")[0]?.trim()
    if (!nin) return
    revalidatingId.value = account.id
    try {
        const response = await accountStore.revalidateNin(nin)
        notify.success(response.data?.message || "NIN revalidated successfully")
        fetch()
    } catch (error: any) {
        notify.error(error.response?.data?.message || "Failed to revalidate NIN")
    } finally {
        revalidatingId.value = null
    }
}

const showReceiverForm = (account: UserAccount) => {
    userName.value = account.givenName + " " + account.surName
    userId.value = account.id
    showMakeReceiverForm.value = true
}

const makeUserOfficialReceiver = async () => {
    loading.value = true
    let payload = {
        individualAccountId: individualAccountId.value,
        backOfficeAccountId: userId.value,
    }

    await api().post("insolvency/official-receivers", payload).then(response => {
        notify.success(response.data.message)
        loading.value = false
        // reload the DOM
        window.location.reload()
    }).catch(error => {
        loading.value = false
        notify.error(error.response.data.message)
    })
}

const selectIndividualAccount = (account: any) => {
    individualAccountId.value = account.id
    userName.value = (userName.value || "") + " Plus " + account.givenName + " " + account.surName
}

// Watchers
watch(() => accountStore.officer_accounts, (data) => {
  if (data) {
        loading.value = false
    accounts.value = data;
    usersList.value = filterUserList(data);
        pagination.value = {
          totalPages: accountStore.pagination?.data.totalPages || 1,
          totalElements: accountStore.pagination?.data.totalElements || 1
        }
    }
})

watch(() => store.getters.getRolesList, (rolesList) => {
    if (rolesList) {
        rolesDataList.value = filterRolesListData(rolesList)
    }
})

watch(() => registerStore.getRegisterError, (userRegisterError) => {
    if (userRegisterError) {
        registerSpinner.value = false
        notify.error(userRegisterError.message)
    }
})

watch(() => registerStore.getRegistrationData, (data) => {
    if (data) {
        notify.success("User registered successfully")
        registerSpinner.value = false
        signatureBlob.value = null
        fetch()
        form.value = {
            idType: "NATIONAL_ID",
            gender: null,
            surname: null,
            givenName: null,
            middleName: null,
            email: null,
            phoneNumber: null,
            roleId: null,
            nationality: "UG",
            idNumber: null,
            idAttachment: null,
            signature: null,
            departmentId: null,
            dob: null
        }
        showAddAccountForm.value = false
        emit("finished", true)
    }
})

watch(() => store.getters.getDepartments, (departments) => {
    if (departments) {
        departmentList.value = departments
    }
})

watch(() => accountStore.reactivationSuccess, (data) => {
    if (data) {
        notify.success(data.message)
        loading.value = true
        closeEditForm()
        fetch()
    }
})

watch(() => accountStore.reactivationError, (error) => {
    if (error) {
        notify.error(error.message)
    }
})

watch(() => rolesStore.revokeRole, (data) => {
    if (data) {
        notify.success("Role removed successfully")
        loading.value = true
        fetch()
        showAccountRoles.value = false
    }
})

watch(() => accountStore.signatureUpdateError, (error) => {
    if (error) {
        notify.error(error.message)
        updateSignatureSpinner.value = false
    }
})

watch(() => accountStore.signatureUpdate, (data) => {
    if (data) {
        notify.success("Signature updated successfully")
        updateSignatureSpinner.value = false
        closeEditSignatureForm()
        fetch()
    }
})

watch(() => accountStore.signatureRemove, (data) => {
    if (data) {
        notify.success(data.message || "Signature removed successfully")
        fetch()
    }
})

watch(() => accountStore.signatureRemoveError, (error) => {
    if (error) {
        notify.error(error.message || "Failed to remove signature")
    }
})

watch(() => accountStore.signatureDetails, (data) => {
    if (data) {
        if (data.status === 400 || data.status === 403 || data.data === null) {
            notify.error(data.message || "Failed to fetch signature details")
        } else {
            let sig = ""
            if (typeof data.data === "string") {
                sig = data.data
            } else if (data.data && typeof data.data.signatureUrl === "string") {
                sig = data.data.signatureUrl
            } else if (typeof data.signatureUrl === "string") {
                sig = data.signatureUrl
            }
            if (sig) {
                editForm.value.signature = sig
            }
        }
    }
})

watch(() => accountStore.signatureDetailsError, (error) => {
    if (error) {
        notify.error(error.message || "Failed to fetch signature details")
    }
})
</script>
